export const nfoListing = `
  query getNfos {
    getNfos {
      liveNfos {
        productId
        imageUrl
        slug
        isinCode
        parentSlug
        fundName
        minInvestment
        nfoMetadata {
          nfoState
          openDate
          closeDate
          allotmentDate
          reopenDate
        }
      }
      upcomingNfos {
        productId
        imageUrl
        fundName
        minInvestment
        slug
        isinCode
        parentSlug
        nfoMetadata {
          nfoState
          openDate
          closeDate
          allotmentDate
          reopenDate
        }
      }
      closedNfos {
        productId
        imageUrl
        fundName
        minInvestment
        slug
        isinCode
        parentSlug
        nfoMetadata {
          nfoState
          openDate
          closeDate
          allotmentDate
          reopenDate
        }
      }
    }
  }
`;

export const nfoDetails = `
query fundDetailv2($fundIsInCode: String!, $planType: PlanType!) {
  fundDetailv2(fundIsInCode: $fundIsInCode, planType: $planType){
    alternateProductId
    fundLegalName
    name
    image
    id
    isin
    nav
    planType
    aum
    disclaimer
    doublesIn
    fundLegalName
    issuingAuthority
    customContent
    purchaseMode
    exitLoadDetail{
      days
     percentage
    }
    minAmount
    minSipAmount
    minSubsequentAmount
    maxSipAmount
    maxLumpsumAmount
    parentSlug
    slug
    sipMultipleAmount
    lumpsumMultipleAmount
    enabled
    subCategory
    category
    allowInvestment
    differenceInReturn
    categoryName
    alpha1Y
    alpha3Y
    allowedSipDates
    alpha5Y
    sipEnabled
    lumpSumEnabled
    monthlyPrimeSipEnabled
    weeklyPrimeSipEnabled
    biWeeklyPrimeSipEnabled
    latestNav {
      dayEndDate
      dayEndNav
      navChange
      navChangePercent
    }
    tags {
      name
      tooltip
    }
    info {
      key
      value
      icon
      tooltip
    }
    returns {
      return1W
      return1M
      return3M
      return6M
      return1Y
      return2Y
      return3Y
      return4Y
      return5Y
      return6Y
      return7Y
      return8Y
      return9Y
      return10Y
      returnALL
    }
    returnsCategory {
      return1M
      return3M
      return6M
      return1Y
      return3Y
      return5Y
      return10Y
      returnALL
    }
    miniInsights {
      insight
      image
      title
    }
    similarFunds {
      productId
      name
      image
      cagr5Y
      expenseRatio
      isinCode
      risk
      rating
      category
      nav
      navChangePercent
      slug
      parentSlug
      exitLoad
      return1M
      return3M
      return6M
      return1Y
      return3Y
      return5Y
      returnALL
      aum
      alpha1Y
      alpha3Y
      alpha5Y
    }
    quote {
      message
      author
      type
    }
    collapsibleInfo {
      faqs {
        title
        faqs {
          question
          answer
        }
      }
      compareSBFD {
        title
        inflation
        sb
        fd
      }
      holdingsSector {
        title
        holdings {
          name
          weighting
        }
        sectors {
          type
          weightage
        }
        holdingGroups {
          type
          weightage
        }
      }
      fundManagerAndAMC {
        title
        fundManager {
          name
          image
          startDate
          tenure
        }
        amc {
          image
          name
          description
          totalSchemes
          aum
          rank
          website
          addressLine1
          addressLine2
          city
          province
          postalCode
          fax
          phone
          custodian
        }
      }
      chargesMF {
        purchase {
          stampDuty
          expenseRatio
        }
        redemption

        title
      }
      compareTopFunds {
        title
      }
      insights {
        title
        finalizedStdDev
        finalizedStdDevCatgory
        insights {
          title
          tooltip
          message
          fund
          catgory
          type
        }
      }
    }
    fundPerformaceData {
      all {
        x
        y
      }
      year {
        x
        y
      }
    }
    catgPerformaceData {
      all {
        x
        y
      }
      year {
        x
        y
      }
    }
    singleCTA
    isNfo
    nfoDetails {
      nfoState
      openDate
      closeDate
      allotmentDate
      reopenDate
    }
  }
}
`;



// WEBPACK FOOTER //
// ./query/nfo.tsx